










































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextarea, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import _ from 'lodash';
import { InfoState } from '@/core';
const cssPrefix = 'beta-signup';

@Component({
  components: {
    ...UUIFComponents,
    SwTextarea,
    SwRadio,
    SwTextfield,
    SwSelect,
    SwCheckbox,
    SwButton,
  },
})

export default class BetaSignupForm extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop()
  formDetails: any;

  formSubmit: boolean = false;
  title: any = '';
  version: any = '';
  isSurveyTaken: boolean = false;
  surveyQs: any[] = [];
  betaAssets: any = [];
  disableControls: boolean = false;
  testInput: any = '';
  tempSurvey: any[] = [];
  accessProduct: boolean = false;
  newBetaAssets: any[] = [];
  showNewAssets: boolean = false;

  get getSurveyOs() {
    return this.tempSurvey;
  }
  getFormDetails() {
    if (this.formDetails.id && this.formDetails.groupID) {
      this.title = this.formDetails.title;
      this.version = this.formDetails.version;
      this.$store.dispatch('BetaProgramStoreModule/getBetaProgramDetails', this.formDetails)
      .then((res:any) => {
        this.$store.commit('stopLoading');
        this.isSurveyTaken = res.content.isSurveyAlreadyTaken;
        this.surveyQs = res.content.arrCompetitiveSurvey ? res.content.arrCompetitiveSurvey : [];
        this.betaAssets = res.content.surveyAssets ? res.content.surveyAssets : [];
        this.surveyQs.map((question:any) => {
          const isFreeFlowText = question.arrChoices.filter((x:any) => x.isFreeFlowText);
          if (question.questionType === 'RADIO' && isFreeFlowText) {
            question.inputText = '';
            question.optionId = '';
          } else if (question.questionType === 'CHECK') {
            question.required = false;
            question.arrChoices.map((x:any) => {
              x.checkedOption = false;
              if (x.isFreeFlowText) {
                x.inputText = '';
              }
            });
          } else if (question.questionType === 'EDIT') {
            question.answer = '';
          } else if (question.questionType === 'LIST') {
            question.listOptions = [];
            question.arrChoices.map((choice:any) => {
              question.listOptions.push({
                id: choice.choiceval,
                value: choice.choiceval,
                label: choice.choicetext,
              });
            });
          }
        });
        this.tempSurvey = _.cloneDeep(this.surveyQs);
        if (!this.betaAssets.length && this.isSurveyTaken) {
          // navigate to download center
          this.formDetails.id = '';
          const url = 'download-center?type=BETA';
          window.open(
            url,
            '_top',
          );
        }
      });
    }
  }
  onRadioChange(quesIndex: any, optIndex: any) {
    if (this.tempSurvey[quesIndex].arrChoices[optIndex].isFreeFlowText) {
      this.tempSurvey[quesIndex].arrChoices[optIndex].checkedOption = true;
    } else {
      this.tempSurvey[quesIndex].inputText = '';
      this.tempSurvey[quesIndex].arrChoices.forEach((item: any, i: any) => {
        if (i !== optIndex) {
          item.checkedOption = false;
        }
      });
    }
  }
  submitForm() {
    this.formSubmit = true;
    const valid = this.isFormValid();
    if (valid) {
      const postData: any = [];
      this.tempSurvey.forEach((element: any) => {
        let obj = { questionId: '', optionId: '', answer: '' };

        if (element.questionType === 'CHECK') {
          element.arrChoices.forEach((opt: any) => {
            if (opt.checkedOption) {
              obj = { questionId: '', optionId: '', answer: '' };
              obj.questionId = element.questionID;
              obj.optionId = opt.choiceval;
              obj.answer = opt.inputText ? opt.inputText : '';
              postData.push(obj);
            }
          });
        } else {
          obj.questionId = element.questionID;
          if (element.answer) {
            obj.answer = element.answer;
          } else if (element.inputText && element.optionId && element.questionType === 'RADIO') {
            obj.answer = element.inputText;
            obj.optionId = element.optionId;
          } else if (element.optionId) {
            obj.optionId = element.optionId;
          }
          postData.push(obj);
        }
      });
      const data = {
        betaSwId: this.formDetails.betaSwId,
        surveyAnswer: postData,
        swGroupId: this.formDetails.groupID,
        surveyServiceId: this.formDetails.id,
      };
      this.$store.dispatch('BetaProgramStoreModule/uploadSurveyData', data)
      .then((resp:any) => {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'MSWAPP:BETASURVEYSUCCESS' || resp.msgCode === 'MSWAPP:SUCCESS') {
          this.accessProduct = true;
          this.disableControls = true;
          this.newBetaAssets = resp.content.surveyAssets ? resp.content.surveyAssets : [];
          if (!this.newBetaAssets.length) {
            this.formDetails.id = '';
            const url = 'download-center?type=BETA';
            window.open(
              url,
              '_top',
            );
          }
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
    }
  }
  isFormValid() {
    let valid: boolean = true;
    this.tempSurvey.forEach((item: any) => {
      if (item.questionType !== 'CHECK' && !item.answer && !item.optionId && (item.isMandatory === 'True')) {
        valid = false;
      }
      if (item.questionType === 'CHECK' && (item.isMandatory === 'True')) {
        const res = item.arrChoices.filter((opt:any) => {
          return (opt.checkedOption === true);
        }).length > 0;
        if (!res) {
          item.required = true;
          valid = false;
        }
      }
    });
    return valid;
  }
  mounted() {
    this.getFormDetails();
  }

  accessBeta() {
    this.showNewAssets = true;
  }

  onclickLinks(links: string) {
    window.open(links, '_blank');
  }
}
